import { useRecoilValue } from "recoil";
import { insetState } from "../../../../../recoil/inset";
import { HomeHeaderWrapper } from "../../styles";
import {
  SkeletonContainer,
  SkeletonText,
  SkeletonIcon,
  SkeletonLeft,
  SkeletonRight,
} from "./styles/skeleton";

const HomeHeaderSkeleton = () => {
  const inset = useRecoilValue(insetState);

  return (
    <HomeHeaderWrapper isLogin={false} inset={inset}>
      <SkeletonContainer>
        <SkeletonLeft>
          <SkeletonText width="120px" height="18px" />
          <SkeletonText width="80px" height="14px" marginTop="4px" />
        </SkeletonLeft>

        <SkeletonRight>
          <SkeletonIcon />
          <SkeletonIcon />
          <SkeletonIcon />
        </SkeletonRight>
      </SkeletonContainer>
    </HomeHeaderWrapper>
  );
};

export default HomeHeaderSkeleton;
